/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classNames from 'classnames';
import * as React from 'react';

import { mapToCssModules } from '../common/utilities';
import IModalFooterProps from './ModalFooter.props';

/**
 * ModalFooter component.
 */
export default class ModalFooter extends React.PureComponent<IModalFooterProps> {
    public static defaultProps: Partial<IModalFooterProps> = {
        tag: 'div'
    };

    public render(): JSX.Element {
        const { className, cssModule, tag, ...attributes } = this.props;
        const Tag = tag || 'div';
        const classes = mapToCssModules(classNames(className, 'msc-modal__footer'), cssModule);
        return <Tag {...attributes} className={classes} />;
    }
}
